module.exports = __webpack_public_path__ + "static/media/jakub-designer.962d983b.png";